// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '@vant/touch-emulator'
import axios from 'axios'
import VueAxios from 'vue-axios'
import qs from 'qs'

import store from './store'//引入Vuex

import Goods from './components/Goods'
import FloatTools from './components/FloatTools'

//import BaiduMap from 'vue-baidu-map'//引入百度地图

import Site from './assets/js/site.js'

import md5 from 'js-md5';

//import AreaList from './assets/js/area.js'

import {
  Button,
  Icon,
  Cell, CellGroup,
  Calendar,
  Card,
  Tag,
  Checkbox, CheckboxGroup,
  Radio, RadioGroup,
  Image,
  Lazyload,
  Swipe, SwipeItem,
  NavBar,
  Sticky,
  Grid, GridItem,
  Stepper,
  SubmitBar,
  Dialog,
  Popup,
  Form,
  DropdownMenu, DropdownItem,
  Field,
  ActionSheet,
  List,
  Toast,
  Collapse, CollapseItem,
  Tab, Tabs,
  Switch,
  Rate,
  Uploader,
  Area,
  Picker,
  Pagination,
  Circle,
  Progress,
  DatetimePicker,
  Search,
  NoticeBar,
  Loading,
  Overlay
} from 'vant'

Vue.use(Button)
  .use(Cell).use(CellGroup)
  .use(Calendar)
  .use(Icon)
  .use(Checkbox).use(CheckboxGroup)
  .use(Radio).use(RadioGroup)
  .use(Card)
  .use(Tag)
  .use(Image)
  .use(Lazyload)
  .use(Swipe).use(SwipeItem)
  .use(NavBar)
  .use(Sticky)
  .use(Grid).use(GridItem)
  .use(Stepper)
  .use(SubmitBar)
  .use(Dialog)
  .use(Popup)
  .use(Form)
  .use(DropdownMenu).use(DropdownItem)
  .use(Field)
  .use(ActionSheet)
  .use(List)
  .use(Toast)
  .use(Collapse).use(CollapseItem)
  .use(Tab).use(Tabs)
  .use(Switch)
  .use(Uploader)
  .use(Rate)
  .use(Picker)
  .use(Area)
  .use(Pagination)
  .use(Circle)
  .use(DatetimePicker)
  .use(Search)
  .use(Progress)
  .use(Loading)
  .use(Overlay)
  .use(NoticeBar);

Vue.use(Site);
//Vue.use(AreaList);

Vue.use(VueAxios, axios);

Vue.use(FloatTools)
  .use(Goods)

//======= 注册自定义组件
Vue.component('FloatTools', FloatTools);
Vue.component('Goods', Goods);
Vue.prototype.qs = qs;


Vue.prototype.$md5 = md5;

//======= 路由守卫
router.beforeEach((to, from, next) => {

  //分享信息
  let metaList = document.getElementsByTagName('meta');
  for (var i = 0; i < metaList.length; i++) {
    if (metaList[i].getAttribute("name") == "shareTitle") {
      metaList[i].content = document.title;
    }
    if (metaList[i].getAttribute("name") == "shareDesc") {
      metaList[i].content = '捷安特发现，带你发现更多精彩';//document.title;
    }
    if (metaList[i].getAttribute("name") == "shareLink") {
      let tmpMeta = metaList[i];
      setTimeout(function(){
        tmpMeta.content = location.href;
      }, 100);
    }
  }

  //路由发生变化修改页面title
  if (to.meta.title) {
    if (to.path === '/') {
      document.title = '捷安特';
    } else {
      document.title = to.meta.title + ' - 捷安特';
    }
  }

  //获取到已登录的用户信息
  let loginuser_data = JSON.parse(localStorage.getItem('giant_userdata'));

  if (loginuser_data && loginuser_data.sessionkey) {
    store.commit('updateLoginUser', loginuser_data);
  } else {
    //判断当前页是否需要登录
    if (to.meta.requireLogin) {
      router.replace({ path: '/login', query: { redirect: location.href }});
      //router.replace({ path: '/login', query: { redirect: location.href }});
      //router.replace({ path: '/login', query: { redirect: to.fullPath } });
      //router.push({ path: '/login', query: { redirect: to.fullPath }});
    }
  }

  next();
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
const _Vue = new Vue({
  router,
  store,
  components: { App },
  render: h => h(App),
}).$mount("#app");

export default _Vue;


// WEBPACK FOOTER //
// ./src/main.js